import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import { getTabButtons, TABS } from "pages/settings/campaign-management/campaignDetails/constants";
import EditCampaignTab from "pages/settings/campaign-management/campaignDetails/Tabs/EditCampaignTab";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 30,
  },
  container: {
    borderRadius: 30,
    padding: 30,
  },
  cardBody: {
    padding: 0,
  },
  tabs: {
    display: "flex",
    padding: "0 30px",
    fontSize: 13,
    fontWeight: 600,
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  tab: {
    boxShadow: "0px -10px 20px rgba(0, 0, 0, 0.05)",
    backgroundColor: "#E1E1E1",
    padding: 18,
    borderRadius: "10px 10px 0px 0px",
    marginRight: 10,

    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DataTabs = ({ campaign, setIsLoading }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(TABS.EDIT_CAMPAIGN);

  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {getTabButtons().map(item => (
          <div
            key={item.key}
            className={classnames(classes.tab, activeTab === item.key && classes.active)}
            data-tab={item.key}
            onClick={onTabClick}
          >
            {item.title}
          </div>
        ))}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          {activeTab === TABS.EDIT_CAMPAIGN && <EditCampaignTab campaign={campaign} setIsLoading={setIsLoading} />}
        </CardBody>
      </Card>
    </div>
  );
};

export default DataTabs;
